import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import UtilsFormule from "../../../utils/UtilsFormule";


const DataTableListCCFournisseur =({ conditionsCommercialFournisseur })=>{
  const navigate = useNavigate();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const { SearchBar } = Search;

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  function partenerTitleFormatter(cell, row) {
    return (
      <>
        {row.partenairFournisseur.fournisseur.matricule}-
        {row.partenairFournisseur.fournisseur.title}
      </>
    );
  }

  function ccTitleFormatter(cell, row) {
    return (
      <>
        {row.conditionCommercialTiers.refCC}-
        {row.conditionCommercialTiers.nameCC}
      </>
    );
  }

  function promoFormatter(cell, row) {
    if (row.conditionCommercialTiers.amount !== 0) {
      return <>{row.conditionCommercialTiers.amount} DNT</>;
    } else {
      return <>{row.conditionCommercialTiers.percent} %</>;
    }
  }

  function startDateFormatter(cell, row) {
    return (
      <>
        {UtilsFormule.formatDateHours(row.conditionCommercialTiers.startDate)}{" "}
        
      </>
    );
  }

  function endDateFormatter(cell, row) {
    return (
      <>
        {UtilsFormule.formatDateHours(row.conditionCommercialTiers.endDate)} 
      </>
    );
  }

  const columns = [
    {
      dataField: "id",
      text: "Client",
      align: "center",
      formatter: partenerTitleFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "id",
      text: "CC",
      align: "center",
      formatter: ccTitleFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "id",
      text: "Promo",
      align: "center",
      formatter: promoFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "id",
      text: "Date début",
      formatter: startDateFormatter,

      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "id",
      text: "Date Fin",
      align: "center",
      headerAlign: "center",
      formatter: endDateFormatter,
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  
  ];

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les conditions commercials Fournisseur</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="factureId"
          data={conditionsCommercialFournisseur}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  //   expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
    </div>
  );


}
export default DataTableListCCFournisseur;